import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.css']
})
export class SubscriptionPlansComponent {
  planType:string = '';

  constructor(private route:ActivatedRoute){}
  

  ngOnInit(){
     this.planType = this.route.snapshot.paramMap.get('planType') || '';
  }
}
